import "./SupportSuccess.css";
import { CircleCheckBig } from "../../../ui";
const TEXT = {
  ar: {
    title: "تم إرسال التذكرة بنجاح!",
    subtitle: "سيتواصل معك فريق الدعم قريباً",
  },
  en: {
    title: "Ticket submitted successfully!",
    subtitle: "Our support team will contact you soon",
  },
};

const SupportSuccess = ({ ticketNumber, lang = "ar" }) => {
  if (!ticketNumber) return null;

  const t = TEXT[lang] || TEXT.ar;

  return (
    <div className="support-success">
  <div className="support-success-icon">
    <CircleCheckBig size={22} />
  </div>

  <div>
    <div className="support-success-title">{t.title}</div>

    <div className="support-success-subtitle">
      {ticketNumber} — {t.subtitle}
    </div>
  </div>
</div>
  );
};

export default SupportSuccess;